const actions = {
    FacilityCategory_REQUEST: 'FacilityCategory_REQUEST',
    FacilityCategory_SUCCESS: 'FacilityCategory_SUCCESS',

    FacilityCategoryRequest: () => ({
        type: actions.FacilityCategory_REQUEST,
        payload: {},
    }),
    FacilityCategorySuccess: (data) => ({
        type: actions.FacilityCategory_SUCCESS,
        payload: {data},
    }),

    SELECTED_FacilityCategory: 'SELECTED_FacilityCategory',
    SelectedFacilityCategory: (data) => ({
        type: actions.SELECTED_FacilityCategory,
        payload: {data},
    })
};
export default actions;

